import { withProps } from 'recompose';
import ObjectInput from '@/se/components/inputs/ObjectInput';

export default withProps({
  schema: {},
})(ObjectInput);
